import {initSlider} from './initSlider';
import {initTabs} from './initTabs';
import {initMovingLine} from '../../common/moving-line';

export const initSlideshowFurniture = () => {
	const components = document.querySelectorAll( 'section.furniture' );

	if ( components.length )
	{
		components.forEach( ( component ) => {
			const tabsContainer = component.querySelector( 'div.tabs' );
			const sliders = Array.from( component.querySelectorAll( 'div.new-slider' ) );
			const slidersSplit = [];

			sliders.forEach( ( slider ) => {
				const updateSlider = initSlider( slider );
				slider.classList.remove( 'not-init' );
				slidersSplit.push( {slider, updateSlider} );
			} );
			
			initTabs( tabsContainer, slidersSplit );
			
			if ( tabsContainer )
			{
				const tabsList = tabsContainer.querySelector( 'ul' );
				
				if ( tabsList )
				{
					initMovingLine( tabsContainer, tabsList, {animDuration: 200} );
				}
			}
		} );
	}
};
